// Libraries
import React, { FC, useCallback } from 'react';
import { ScatterPlotDatum, ScatterPlotNodeProps } from '@nivo/scatterplot';
import { animated } from '@react-spring/web';

// Utils
import { getColor } from '@/utils/colors';

const interpolateRadius = (size: number) => size / 2;

type ScatterChartCircleProps = ScatterPlotNodeProps<ScatterPlotDatum>;

const ScatterChartCircle: FC<ScatterChartCircleProps> = (props) => {
  const {
    node,
    style,
    blendMode,
    isInteractive,
    onMouseEnter,
    onMouseMove,
    onMouseLeave,
    onClick,
  } = props;

  const handleMouseEnter = useCallback(
    (event) => onMouseEnter?.(node, event),
    [node, onMouseEnter]
  );
  const handleMouseMove = useCallback(
    (event) => onMouseMove?.(node, event),
    [node, onMouseMove]
  );
  const handleMouseLeave = useCallback(
    (event) => onMouseLeave?.(node, event),
    [node, onMouseLeave]
  );
  const handleClick = useCallback(
    (event) => onClick?.(node, event),
    [node, onClick]
  );

  return (
    <animated.circle
      cx={style.x}
      cy={style.y}
      r={style.size.to(interpolateRadius)}
      fill={getColor(
        typeof node.xValue === 'number' ? node.xValue : Number(node.xValue)
      )}
      stroke="#fff"
      style={{
        mixBlendMode: blendMode,
        zIndex: `${Number(node.xValue) * 100}px`,
      }}
      onMouseEnter={isInteractive ? handleMouseEnter : undefined}
      onMouseMove={isInteractive ? handleMouseMove : undefined}
      onMouseLeave={isInteractive ? handleMouseLeave : undefined}
      onClick={isInteractive ? handleClick : undefined}
    />
  );
};

export default ScatterChartCircle;
